import {
    FaTachometerAlt,
    FaUsers,
    FaChartLine,
    FaChartBar,
} from "react-icons/fa";

const modules = [
    {
        id: 1,
        name: "Overview",
        path: "/",
        icon: FaTachometerAlt,
    },
    {
        id: 2,
        name: "Employees",
        path: "/employees",
        icon: FaUsers,
    },
    {
        id: 3,
        name: "KRA Management",
        path: "/kra-management",
        icon: FaChartLine,
    },
    {
        id: 4,
        name: "KPI Management",
        path: "/kpi-management",
        icon: FaChartBar,
    },
    {
        id: 5,
        name: "Report",
        path: "/reports",
        icon: FaTachometerAlt,
        subModules: [
            {
                id: 6,
                name: "KPI Summary",
                path: "/kpi-summary",
            },
            {
                id: 7,
                name: "Department-Wise Report",
                path: "/department-wise-report",
            },
            {
                id: 7,
                name: "KRA Report",
                path: "/kra-report",
            },
        ],
    },
]

export type moduleType = typeof modules;

export default modules;